import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  transfersShippingService,
  type TransfersShippingCompleteParams,
} from '@/services/transfers-shipping';
import { queryKeys } from '@/lib/queryKeys';
import { useNotifications } from '@/stores/useNotificationStore';
import { getErrorMessage } from '@/utils/httpClient';

export const useCompleteShipment = () => {
  const queryClient = useQueryClient();
  const notifications = useNotifications();

  return useMutation({
    mutationFn: (params: TransfersShippingCompleteParams) =>
      transfersShippingService.completeShipment(params),
    onSuccess: (result) => {
      notifications.success(
        'Shipment Complete',
        `${result.totalQuantity} item${result.totalQuantity === 1 ? '' : 's'} shipped.`,
      );
      void queryClient.invalidateQueries({ queryKey: ['asset-inventory'] });
      void queryClient.invalidateQueries({ queryKey: queryKeys.transfersShipping.all });
      void queryClient.invalidateQueries({ queryKey: queryKeys.transactions.all });
    },
    onError: (error) => {
      notifications.error('Shipment Failed', getErrorMessage(error));
    },
  });
};
